import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DistributeCenterV } from '../icons';
import { ToolbarButton } from '../ui';
import { getAlignToContainer, getSelectedObjectsIDs } from '../editor';
import { getCurrentPiece, distributeObjectsCenterV } from '../project';

const ButtonDistributeCenterV = ({ disabled, onClick }) => {
  if (disabled) {
    return null;
  }

  return <ToolbarButton icon={<DistributeCenterV />} onClick={onClick} />;
};

ButtonDistributeCenterV.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const reduxConnector = connect(
  state => {
    let container = getCurrentPiece(state);
    if (!getAlignToContainer(state)) {
      container = null;
    }

    const ids = getSelectedObjectsIDs(state);
    let disabled = true;
    if (ids.size >= 2) {
      disabled = false;
    }
    return { ids, disabled, container };
  },
  { distributeObjectsCenterV },
  ({ ids, container, ...state }, actions) => ({
    ...state,
    onClick: () => actions.distributeObjectsCenterV({ ids, container }),
  }),
);

export default reduxConnector(ButtonDistributeCenterV);
